<template>
  <div>
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Conjuntos de imagens</h1>
        </div>
        <div class="md-toolbar-section-end">
          <md-button class="md-primary md-raised" @click.stop="openCadastrar">
            Cadastrar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Titulo</md-table-head>
        <md-table-head>Descrição</md-table-head>
        <md-table-head />
      </md-table-row>
      <md-table-row
        v-for="graphical in graphicals"
        :key="graphical.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ graphical.titulo }}</md-table-cell>
        <md-table-cell>{{ graphical.descricao }}</md-table-cell>
        <md-table-cell>
          <router-link
            :to="{
              name: 'GraphicalViewFile',
              params: { localId: localId, graphicalId: graphical.id },
            }"
          >
            <md-button class="md-primary"> Configurar </md-button>
          </router-link>

          <md-button
            class="md-primary"
            @click.stop="() => editarGraphical(graphical.id)"
          >
            Editar
          </md-button>

          <md-button
            class="md-accent"
            @click="() => (deleteGraphicalId = graphical.id)"
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="deveAbrirModalDeleteGraphical"
      md-title="Tem certeza?"
      md-content="Deletar um conjunto é uma ação irreversível. Após concluída os dados do conjunto não poderão ser recuperados"
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-clicked-outside="deleteGraphicalId = null"
      @md-cancel="deleteGraphicalId = null"
      @md-confirm="() => deletarGraphical()"
    />

    <slider-right id="slideLeft" ref="slider" size="30%">
      <GraphicalForm
        :key="editarGraphicalId"
        :local-id="$route.params.localId"
        :graphical-id="editarGraphicalId"
        @update="() => buscarGraphicals()"
        @close="() => closeCreate()"
      />
    </slider-right>
  </div>
</template>

<script>
import SliderRight from '../../../components/SliderLeft.vue'
import GraphicalForm from '../../../components/view/graphical-view/GraphicalForm.vue'
import http from '../../../utils/http'

export default {
  name: 'GraphicalIndex',
  components: { SliderRight, GraphicalForm },
  data() {
    return {
      deleteGraphicalId: null,
      editarGraphicalId: null,
      graphicals: [],
      localId: '',
    }
  },
  computed: {
    deveAbrirModalDeleteGraphical() {
      return this.deleteGraphicalId !== null
    },
  },
  async mounted() {
    this.localId = this.$route.params.localId
    await this.buscarGraphicals()
  },
  methods: {
    openCadastrar() {
      this.editarGraphicalId = null
      this.$refs.slider.toogleTab()
    },
    closeCreate() {
      this.$refs.slider.toogleTab()
      this.editarGraphicalId = null
    },
    async editarGraphical(graphicalId) {
      this.editarGraphicalId = graphicalId
      this.$refs.slider.toogleTab()
    },
    async buscarGraphicals() {
      const response = await http.get(`graphical-view`)

      this.graphicals = response?.graphicalViews || []
    },
    deletarGraphical() {
      http.delete(`graphical-view/`, this.deleteGraphicalId).then(() => {
        this.graphicals = this.graphicals.filter(
          (graphical) => graphical.id !== this.deleteGraphicalId
        )
        this.deleteGraphicalId = null
      })
    },
  },
}
</script>
